import { api } from "constants/RotasAPI";
import useDelete from "hooks/useDelete";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ExcluirHistoricoProcessoJudicialDTO } from "types/dto/ExcluirHistoricoProcessoJudicialDTO";
import { ResponseDTO } from "types/dto/ResponseDTO";

export const useDeleteProcessoJudicialHistorico = () => {
  const onSuccess = (request: number, resposne: ResponseDTO<ExcluirHistoricoProcessoJudicialDTO>) => {
    if (resposne.errorMessage) {
      toast.error(resposne.errorMessage);
    } else {
      toast.success("Histórico excluído com sucesso!");
      queryClient.invalidateQueries(["processos-judiciais-historicos"]);
    }
  };

  return useDelete<number>({
    url: `${api.processosJudiciaisHistorico.deleteHistoricoProcessoJudicial}`,
    onSuccess,
  });
};
